<template>
  <container-wrapper
    :class="[selected ? 'selected' : '', widget.type]"
    @click.stop="selectWidget(widget)"
    :designer="designer"
    :widget="widget"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
  >
    <van-cell-group :title="widget.options.label" :border="widget.options.border" :inset="widget.options.inset">
      <draggable
        :list="widget.widgetList"
        item-key="id"
        v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 200 }"
        handle=".drag-handler"
        :component-data="{ inSubFormFlag: getSubFormFieldFlag() }"
        @add="evt => onContainerDragAdd(evt, widget.widgetList)"
        @update="onContainerDragUpdate"
        :move="checkContainerMove"
        class="m-cell-group"
        style="min-height: 30px"
      >
        <template #item="{ element: subWidget, index: swIdx }">
          <template v-if="'container' === subWidget.category">
            <component
              :is="subWidget.type + '-widget'"
              :widget="subWidget"
              :designer="designer"
              :key="subWidget.id"
              :parent-list="widget.widgetList"
              :index-of-parent-list="swIdx"
              :parent-widget="widget"
            ></component>
          </template>
          <template v-else>
            <component
              :is="subWidget.type + '-widget'"
              :field="subWidget"
              :designer="designer"
              :key="subWidget.id"
              :parent-list="widget.widgetList"
              :index-of-parent-list="swIdx"
              :parent-widget="widget"
              :design-state="true"
            ></component>
          </template>
        </template>
      </draggable>
    </van-cell-group>
  </container-wrapper>
</template>

<script>
import { computed, inject } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useContainer } from '@/components/form-designer/form-widget/container-widget/containerMixin';
import { useDesignRef } from '@/components/form-designer/refMixinDesign';
import ContainerWrapper from '@/components/form-designer/form-widget/container-widget/container-wrapper';
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';

export default {
  componentName: 'ContainerWidget',
  components: {
    ContainerWrapper,
    ...FieldComponents,
  },
  name: 'm-cell-group-widget',
  props: {
    designer: Object,
    indexOfParentList: Number,
    parentList: Array,
    parentWidget: Object,
    widget: Object,
  },
  setup(props) {
    const refList = inject('refList');

    const { i18nt } = useI18n();
    const containerMixin = useContainer();
    const designRefMixin = useDesignRef();

    const selected = computed(() => {
      return props.widget.id === props.designer.selectedId;
    });

    const customClass = computed(() => {
      return props.widget.options.customClass || '';
    });

    designRefMixin.initRefList();
    return {
      i18nt,
      ...containerMixin,
      ...designRefMixin,

      customClass,
      selected,
    };
  },
};
</script>

<style lang="scss" scoped>
div.form-widget-list {
  min-height: 28px;
}

.container-wrapper.m-cell-group {
  box-sizing: border-box;
  padding-bottom: 10px;
}

:deep(.van-cell-group--inset) .field-wrapper:first-of-type {
  border-radius: 8px;
  &.selected::after {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
:deep(.van-cell-group--inset) .field-wrapper:last-of-type {
  border-radius: 8px;
  &.selected::after {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
</style>
